import FAQItem from 'components/FaqItem'
import TextTitle from 'components/TextTitle'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_ALIGN_ITEMS } from 'modules/styles/constants/index.cjs'
import React from 'react'
import {
  defineMessages,
  useIntl
} from 'react-intl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

const messages = defineMessages({
  title: {
    id: 'FAQSection.title',
    defaultMessage: 'Frequently Asked Questions'
  },
  q1: {
    id: 'FAQSection.q1',
    defaultMessage: 'What fitness level is this for?'
  },
  a1: {
    id: 'FAQSection.a1',
    defaultMessage: 'Nutrition is an important piece of your lifestyle. However, we want to fix your training habits before we introduce nutrition changes. We will provide nutrition plans in the future.'
  },
  q2: {
    id: 'FAQSection.q2',
    defaultMessage: 'How long is this plan for?'
  },
  q3: {
    id: 'FAQSection.q3',
    defaultMessage: 'What about nutrition?'
  }
})

export default function FaqSection ({ isDesktopStylingEnabled }) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()

  const isResponsive = !isSmallScreen && isDesktopStylingEnabled

  return (
    <View
      id='faq'
      mb='4em'
    >
      <TextTitle
        fs={!isResponsive ? '1.75em' : '3.75em'}
        mt='2.5em'
        mb='2.06em'
        mr='2em'
        ml='2em'
        style={{ textAlign: STYLES_ALIGN_ITEMS.CENTER }}
      >
        {formatMessageIntlUtil(intl, messages.title)}
      </TextTitle>
      <View
        pl='1.04em'
        pr='1.04em'
        w={!isResponsive ? 'unset' : '1103px'}
        m={!isResponsive ? 'unset' : '0 auto'}
      >
        <FAQItem
          isDesktopStylingEnabled={isDesktopStylingEnabled}
          question={formatMessageIntlUtil(intl, messages.q1)}
          answer={formatMessageIntlUtil(intl, messages.a1)}
        />
        <FAQItem
          isDesktopStylingEnabled={isDesktopStylingEnabled}
          question={formatMessageIntlUtil(intl, messages.q2)}
          answer={formatMessageIntlUtil(intl, messages.a1)}
        />
        <FAQItem
          isDesktopStylingEnabled={isDesktopStylingEnabled}
          question={formatMessageIntlUtil(intl, messages.q3)}
          answer={formatMessageIntlUtil(intl, messages.a1)}
        />
      </View>
    </View>
  )
}
